/**
 * Fits the 640x360 menu canvas to the window the way the render pipeline fits the game image
 * (05 §8 pass 7): the largest whole number of device pixels per logical pixel, centred. Pure.
 */

export const CANVAS_W = 640;
export const CANVAS_H = 360;

export interface MenuLayout {
  /** Whole device pixels per logical pixel: the game's pixel scale. */
  pixelScale: number;
  /** The CSS `scale()` that gives that pixel scale at this device pixel ratio. */
  scale: number;
  /** Top-left corner of the canvas in CSS pixels. */
  left: number;
  top: number;
}

/** `winW`/`winH` are CSS pixels (`innerWidth`/`innerHeight`); `dpr` is `devicePixelRatio`. */
export function chooseLayout(winW: number, winH: number, dpr = 1): MenuLayout {
  const pr = Number.isFinite(dpr) && dpr > 0 ? dpr : 1;
  const bw = Math.max(0, Math.floor(winW * pr));
  const bh = Math.max(0, Math.floor(winH * pr));
  const pixelScale = Math.max(1, Math.floor(Math.min(bw / CANVAS_W, bh / CANVAS_H)));
  const w = CANVAS_W * pixelScale;
  const h = CANVAS_H * pixelScale;
  // Same rounding as RenderPipeline: the left margin rounds down, the top margin rounds up.
  // A window smaller than the canvas keeps the top-left corner on screen rather than centring.
  const left = Math.max(0, Math.floor((bw - w) / 2)) / pr;
  const top = Math.max(0, bh - Math.floor((bh - h) / 2) - h) / pr;
  return { pixelScale, scale: pixelScale / pr, left, top };
}
